import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ui-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  @Input() isLoading: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
